
import React, { useState, useRef, useEffect } from "react";
import TopHeader from "./Topheader.js";

const Header = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const timeoutRef = useRef(null);
  const mobileMenuRef = useRef(null);

  const handleMouseEnter = (dropdownId) => {
    clearTimeout(timeoutRef.current);
    setOpenDropdown(dropdownId);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setOpenDropdown(null);
    }, 200);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
    if (isMobileMenuOpen) setOpenDropdown(null);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setOpenDropdown(null);
  };

  const handleClickOutside = (event) => {
    if (
      mobileMenuRef.current &&
      !mobileMenuRef.current.contains(event.target)
    ) {
      closeMobileMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  return (
    <>
              
    
    <header className="bg-white w-full fixed top-0 left-0 z-30 shadow-md header-gradient">
      <TopHeader/>
      <div>
        <nav
          className="flex items-center justify-between p-6 lg:px-4"
          aria-label="Global Navigation"
        >
          <a href="/" className="flex items-center space-x-3">
            <img
              src="/assets/logo.png"
              alt="Ayanshtech Solutions Logo"
              className="h-12 w-12"
            />
            <div>
              <h2 className="text-lg font-bold text-gray-900 mr-2">
                Ayanshtech Solutions
              </h2>
              <p className="hidden sm:block text-sm text-blue-700 font-medium">
                A Place of Innovation
              </p>
            </div>
          </a>

          {/* Desktop Navigation Links */}
          <div className="hidden lg:flex lg:gap-x-12 mr-30 ml-2">
            <div>
              <a
                href="/about-us"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">About Us</button>
              </a>
            </div>
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("devops")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                type="button"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                DevOps
              </button>
              
              {openDropdown === "devops" && (
                <div className="absolute left-[12vw] -translate-x-1/2 top-full z-10 mt-3 w-screen max-w-7xl px-10 ml-24 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 border-t-4 border-blue-500">
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3">
                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/devops-aws"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo5.png"
                              alt="AWS Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AWS Solutions
                          </a>
                        </li>
                        <li>
                          <a
                            href="/devops-azure"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo6.png"
                              alt="Azure Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Azure Solutions
                          </a>
                        </li>
                        
                        <li>
                          <a
                            href="/devops-cloud-native"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo8.png"
                              alt="Cloud Deployments Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Cloud Deployments (EKS, AKS, GKE)
                          </a>
                        </li>
                        <li>
                          <a
                            href="/migration"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo7.png"
                              alt="Cloud Migration Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Cloud Migration
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/devops-docker"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo8.png"
                              alt="Docker Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Docker & Containers
                          </a>
                        </li>
                        <li>
                          <a
                            href="/devops-kubernetes"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo9.png"
                              alt="Kubernetes Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Kubernetes Clusters
                          </a>
                        </li>
                        
                      </ul>
                    </div>
                    <div>
                      <ul className="text-left space-y-3">

                        <li>
                          <a
                            href="/devops-ci-cd"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo7.png"
                              alt="CI/CD Icon"
                              className="h-8 w-8 mr-3"
                            />
                            CI/CD Pipelines
                          </a>
                        </li>
                        <li>
                          <a
                            href="/devops-security"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo1.png"
                              alt="Security Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Security Scanning (Snyk, SonarQube)
                          </a>
                        </li>
                      </ul>
                    </div>
                   
                  </div>
                  <hr className="border-t-2 border-gray-300" />
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-5 mb-4 text-center">
                    <div>
                      <h4 className="text-lg font-semibold">India</h4>
                      <p className="text-pink-600">+91-8802319226</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">USA</h4>
                      <p className="text-pink-600">+1-917-283-4232</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">Email Enquiries</h4>
                      <p className="text-pink-600">info@ayanshtechnology.com</p>
                    </div>
                  </div>
                </div>
              )}
            </div>
<div>
              <a
                href="/hetzner-cloud-migration"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Hetzner Migration</button>
              </a>
            </div>
            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("ai-agent")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                type="button"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                AI Automation
              </button>
              {openDropdown === "ai-agent" && (
                <div className="absolute left-[12vw] -translate-x-1/2 top-full z-10 mt-3 w-screen max-w-4xl px-10 ml-24 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 border-t-4 border-blue-500">
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/ai-calling-agent"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo4.png"
                              alt="AI Calling Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AI Calling Agent
                          </a>
                        </li>
                        
                        <li>
                          <a
                            href="/ai-support-bot"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo6.png"
                              alt="Support Bot Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AI Support Bot
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/ai-agent"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo7.png"
                              alt="AI Agent Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Autonomous AI Agent
                          </a>
                        </li>
                        <li>
                          <a
                            href="/ai-chatbot"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo8.png"
                              alt="Chatbot Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AI Chatbot
                          </a>
                        </li>
                        
                      </ul>
                    </div>
                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/ai-data-agent"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo10.png"
                              alt="Data Agent Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Data Intelligence Agent
                          </a>
                        </li>
                        <li>
                          <a
                            href="/voice-assistant"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo1.png"
                              alt="Voice Bot Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AI Voice Assistant
                          </a>
                        </li>
                        <li>
                          <a
                            href="/ai-custom-agent"
                            className="flex items-center hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo2.png"
                              alt="Custom Agent Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Custom AI Agent
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <hr className="border-t-2 border-gray-300" />
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-5 mb-4 text-center">
                    <div>
                      <h4 className="text-lg font-semibold">India</h4>
                      <p className="text-pink-600">+91-8802319226</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">USA</h4>
                      <p className="text-pink-600">+1-917-283-4232</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">Email Enquiries</h4>
                      <p className="text-pink-600">info@ayanshtechnology.com</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("voip")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                type="button"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                VoIP Solutions
              </button>
              {openDropdown === "voip" && (
                <div
                  className="absolute  top-full z-10 mt-4 w-screen max-w-4xl overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 border-t-4 border-blue-500"
                  style={{ transform: "translateX(-40%)" }}
                >
                  {/* Dropdown content for VoIP Solutions */}
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 ml-6">
                    <div>
                      <ul className="text-left space-y-3">
                       
                        <li>
                          <a
                            href="/dynamic-ivr-solution"
                            className="flex items-center  hover:gradient-text-hover  text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo10.png"
                              alt="Logo"
                              className="h-8 w-8 mr-3"
                            />
                            Dynamic IVR Solution
                          </a>
                        </li>
                        <li>
                          <a
                            href="/sms-broadcasting-system"
                            className="flex items-center  hover:gradient-text-hover  text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo1.png"
                              alt="Logo"
                              className="h-8 w-8 mr-3"
                            />
                            Voice Broadcasting Solution
                          </a>
                        </li>
                        
                      </ul>
                    </div>

                    <div>
                      <ul className="text-left space-y-3">

                        <li>
                          <a
                            href="/contact-center-solution"
                            className="flex items-center  hover:gradient-text-hover  text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo3.png"
                              alt="Logo"
                              className="h-8 w-8 mr-3"
                            />
                            Call Center Solution
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/communication-api"
                            className="flex items-center  hover:gradient-text-hover  text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo5.png"
                              alt="Logo"
                              className="h-8 w-8 mr-3"
                            />
                            Communication APIs
                          </a>
                        </li>
                        
                      </ul>
                    </div>
                  </div>

                  <hr className="border-t-2 border-gray-300" />
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6 mb-4 text-center">
                    <div>
                      <h4 className="text-lg font-semibold">India</h4>
                      <p className="text-pink-600">+91-8802319226</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">USA</h4>
                      <p className="text-pink-600">+1-917-283-4232</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">Email Enquiries</h4>
                      <p className="text-pink-600">info@ayanshtechnology.com</p>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div
              className="relative"
              onMouseEnter={() => handleMouseEnter("hire")}
              onMouseLeave={handleMouseLeave}
            >
              <button
                type="button"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                Hire Developers
              </button>
              {openDropdown === "hire" && (
                <div
                  className="absolute top-full z-10 mt-3 w-screen max-w-5xl overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5 border-t-4 border-blue-500"
                  style={{ transform: "translateX(-60%)" }}
                >
                  <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-3">
                    <div>
                      <ul className="text-left space-y-3">
                        
                        <li>
                          <a
                            href="/hire-azure-devops"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo2.png"
                              alt="MERN Developer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Azure Engineer
                          </a>
                        </li>
                         <li>
                          <a
                            href="/hire-aws-migration-engineers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo1.png"
                              alt="AWS Migration Engineer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            AWS Migration Engineers
                          </a>
                        </li>
                        <li>
                          <a
                            href="/hire-devops-engineers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo2.png"
                              alt="DevOps Engineer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            DevOps Engineer
                          </a>
                        </li>
                        
                        
                      </ul>
                    </div>

                    <div>
                      <ul className="text-left space-y-3">
                        <li>
                          <a
                            href="/hire-asterisk-developers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo2.png"
                              alt="Asterisk Developer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            Asterisk Developer
                          </a>
                        </li>
                        <li>
                          <a
                            href="/hire-freeswitch-developers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo9.png"
                              alt="FreeSWITCH Developer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            FreeSWITCH Developers
                          </a>
                        </li>
                        
                      </ul>
                    </div>

                    <div>
                      <ul className="text-left space-y-3">
                        
                        <li>
                          <a
                            href="/hire-voip-developers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo8.png"
                              alt="VoIP Developer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            VoIP Developer
                          </a>
                        </li>
                        <li>
                          <a
                            href="/hire-webrtc-developers"
                            className="flex items-center  hover:gradient-text-hover text-lg"
                          >
                            <img
                              src="\assets\icons\HeaderIcons\logo9.png"
                              alt="WebRTC Developer Icon"
                              className="h-8 w-8 mr-3"
                            />
                            WebRTC Developer
                          </a>
                        </li>
                      </ul>
                    </div>
                    
                  </div>
                  <hr className="border-t-2 border-gray-300" />

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-6 text-center mb-4">
                    <div>
                      <h4 className="text-lg font-semibold">India</h4>
                      <p className="text-pink-600">+91-8802319226</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">USA</h4>
                      <p className="text-pink-600">+1-917-283-4232</p>
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold">Email Enquiries</h4>
                      <p className="text-pink-600">info@ayanshtechnology.com</p>
                    </div>
                  </div>
                </div>
              )}
            </div>


            <div>
              <a
                href="/products"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Products</button>
              </a>
            </div>

            {/* <div>
              <a
                href="/portfolio/portfolio.html"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Portfolio</button>
              </a>
            </div> */}

            <div>
              <a
                href="/contactUs"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Contact</button>
              </a>
            </div>

            {/* <div>
              <a
                href="/#"
                className="flex items-center gap-x-1 text-l font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">About Us</button>
              </a>
            </div> */}
          </div>

          {/* Contact Us Button and Hamburger Menu */}
          <div className="flex items-center">
            <div className="lg:hidden ml-4">
              <button
                onClick={toggleMobileMenu}
                className="text-gray-900 focus:outline-none"
              >
                {isMobileMenuOpen ? (
                  <svg
                    className="w-10 h-10"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                ) : (
                  <svg
                    className="w-10 h-10"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16m-7 6h7"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </nav>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          ref={mobileMenuRef}
          className={`lg:hidden fixed top-0 right-0 h-full w-60 bg-blue-100 shadow-lg transition-transform transform ${isMobileMenuOpen ? "translate-x-0" : "translate-x-full"
            }`}
        >
          <div className="flex flex-col gap-4 p-4 max-h-full overflow-y-auto">
           <div>
              <a
                href="/about-us"
                className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">AboutUs</button>
              </a>
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("devops-mobile")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700">
                DevOps
              </button>
              {openDropdown === "devops-mobile" && (
                <div className="p-4 rounded-lg">
                  <ul className="text-left space-y-3">
                    <li>
                      <a href="/devops-aws" className="text-black hover:text-blue-700">
                        AWS Solutions
                      </a>
                    </li>
                    <li>
                      <a href="/devops-azure" className="text-black hover:text-blue-700">
                        Azure Solutions
                      </a>
                    </li>
                    <li>
                      <a href="/devops-cloud-native" className="text-black hover:text-blue-700">
                        Cloud Deployments (EKS, AKS, GKE)
                      </a>
                    </li>
                    <li>
                      <a href="/migration" className="text-black hover:text-blue-700">
                        Cloud Migration
                      </a>
                    </li>
                    <li>
                      <a href="/devops-docker" className="text-black hover:text-blue-700">
                        Docker & Containers
                      </a>
                    </li>
                    <li>
                      <a href="/devops-kubernetes" className="text-black hover:text-blue-700">
                        Kubernetes Clusters
                      </a>
                    </li>

                    <li>
                      <a href="/devops-ci-cd" className="text-black hover:text-blue-700">
                        CI/CD Pipelines
                      </a>
                    </li>
                    
                    <li>
                      <a href="/devops-security" className="text-black hover:text-blue-700">
                        Security Scanning (Snyk, SonarQube)
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("ai-agent-mobile")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700">
                AI Agent
              </button>
              {openDropdown === "ai-agent-mobile" && (
                <div className="p-4 rounded-lg">
                  <ul className="text-left space-y-3">
                    <li>
                      <a href="/ai-calling-agent" className="text-black hover:text-blue-700">
                        AI Calling Agent
                      </a>
                    </li>
                    
                    <li>
                      <a href="/ai-support-bot" className="text-black hover:text-blue-700">
                        AI Support Bot
                      </a>
                    </li>
                    <li>
                      <a href="/ai-agent" className="text-black hover:text-blue-700">
                        Autonomous AI Agent
                      </a>
                    </li>
                    <li>
                      <a href="/ai-chatbot" className="text-black hover:text-blue-700">
                        AI Chatbot
                      </a>
                    </li>
                   
                    <li>
                      <a href="/ai-data-agent" className="text-black hover:text-blue-700">
                        Data Intelligence Agent
                      </a>
                    </li>
                    <li>
                      <a href="//voice-assistant" className="text-black hover:text-blue-700">
                       AI Voice Assistant
                      </a>
                    </li>
                    <li>
                      <a href="/ai-custom-agent" className="text-black hover:text-blue-700">
                        Custom AI Agent
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("voip-solutions")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700">
                VoIP Solutions
              </button>
              {openDropdown === "voip-solutions" && (
                <div className="p-4 rounded-lg">
                  {/* Dropdown content for VoIP Solutions */}
                  <ul className="text-left space-y-3">
                    
                    <li>
                      <a
                        href="/dynamic-ivr-solution"
                        className="text-black hover:text-blue-700"
                      >
                        Dynamic IVR Solution
                      </a>
                    </li>
                    <li>
                      <a
                        href="/sms-broadcasting-system"
                        className="text-black hover:text-blue-700"
                      >
                        Voice Broadcasting Solution
                      </a>
                    </li>
                    
                    <li>
                      <a
                        href="/contact-center-solution"
                        className="text-black hover:text-blue-700"
                      >
                        Contact Center Solution
                      </a>
                    </li>
                    
                    <li>
                      <a
                        href="/communication-api"
                        className="text-black hover:text-blue-700"
                      >
                        Communication APIs
                      </a>
                    </li>
                    
                  </ul>
                </div>
              )}
            </div>

            <div
              onMouseEnter={() => handleMouseEnter("hire-developers")}
              onMouseLeave={handleMouseLeave}
            >
              <button className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700">
                Hire Developers
              </button>
              {openDropdown === "hire-developers" && (
                <div className="p-4  rounded-lg">
                  <ul class="text-left space-y-3">
                    <li>
                      <a
                        href="/hire-azure-devops"
                        class="text-black hover:text-blue-700"
                      >
                        Azure Engineers
                      </a>
                    </li>
                    <li>
                      <a
                        href="/hire-freeswitch-developers"
                        class="text-black hover:text-blue-700"
                      >
                        Freeswitch Developers
                      </a>
                    </li>
                    
                    <li>
                      <a
                        href="/hire-asterisk-developers"
                        class="text-black hover:text-blue-700"
                      >
                        Asterisk Developer
                      </a>
                    </li>
                    

                    <li>
                      <a
                        href="/hire-voip-developers"
                        class="text-black hover:text-blue-700"
                      >
                        VoIP Developer
                      </a>
                    </li>
                    <li>
                      <a
                        href="/hire-webrtc-developers"
                        class="text-black hover:text-blue-700"
                      >
                        WebRTC Developer
                      </a>
                    </li>
                    
                    <li>
                      <a
                        href="/hire-aws-migration-engineers"
                        class="text-black hover:text-blue-700"
                      >
                        AWS Migration Engineers
                      </a>
                    </li>
                    <li>
                      <a
                        href="/hire-devops-engineers"
                        class="text-black hover:text-blue-700"
                      >
                        DevOps Engineer
                      </a>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <div>
              <a
                href="/products"
                className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Products</button>
              </a>
            </div>
            
            <div>
              <a
                href="/contactUs"
                className="text-sm font-bold leading-6 text-gray-900 hover:text-blue-700"
              >
                <button type="button">Contact</button>
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  </>);
};

export default Header;
